var _rect, _path, _path2, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEyeOutline = function SvgEyeOutline(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1640 -1307C-1640 -1362.23 -1595.23 -1407 -1540 -1407H30486C30541.2 -1407 30586 -1362.23 30586 -1307V10563C30586 10618.2 30541.2 10663 30486 10663H-1540C-1595.23 10663 -1640 10618.2 -1640 10563V-1307Z",
    fill: "#E7E7E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-1540 -1406H30486V-1408H-1540V-1406ZM30585 -1307V10563H30587V-1307H30585ZM30486 10662H-1540V10664H30486V10662ZM-1639 10563V-1307H-1641V10563H-1639ZM-1540 10662C-1594.68 10662 -1639 10617.7 -1639 10563H-1641C-1641 10618.8 -1595.78 10664 -1540 10664V10662ZM30585 10563C30585 10617.7 30540.7 10662 30486 10662V10664C30541.8 10664 30587 10618.8 30587 10563H30585ZM30486 -1406C30540.7 -1406 30585 -1361.68 30585 -1307H30587C30587 -1362.78 30541.8 -1408 30486 -1408V-1406ZM-1540 -1408C-1595.78 -1408 -1641 -1362.78 -1641 -1307H-1639C-1639 -1361.68 -1594.68 -1406 -1540 -1406V-1408Z",
    fill: "black",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1500,
    height: 900,
    transform: "translate(-1316 -354)",
    fill: "#F2F2F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1397_6495)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1072,
    y: -302,
    width: 1238,
    height: 830,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1397_6495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1056 -56H150V456C150 458.209 148.209 460 146 460H-1052C-1054.21 460 -1056 458.209 -1056 456V-56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1206,
    height: 774.641,
    transform: "translate(-1056 -56)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -53.25,
    y: -13.4395,
    width: 203,
    height: 42.3856,
    stroke: "#EAECF0",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.15031 5.89673C8.6428 5.89673 9.11512 6.09237 9.46336 6.44061C9.8116 6.78885 10.0072 7.26117 10.0072 7.75366C10.0072 8.24615 9.8116 8.71847 9.46336 9.06671C9.11512 9.41496 8.6428 9.6106 8.15031 9.6106C7.65782 9.6106 7.1855 9.41496 6.83726 9.06671C6.48902 8.71847 6.29338 8.24615 6.29338 7.75366C6.29338 7.26117 6.48902 6.78885 6.83726 6.44061C7.1855 6.09237 7.65782 5.89673 8.15031 5.89673ZM8.15031 3.11133C11.2452 3.11133 13.8882 5.03635 14.9591 7.75366C13.8882 10.471 11.2452 12.396 8.15031 12.396C5.05542 12.396 2.41238 10.471 1.34155 7.75366C2.41238 5.03635 5.05542 3.11133 8.15031 3.11133ZM2.69092 7.75366C3.19122 8.77517 3.96807 9.63582 4.93316 10.2378C5.89825 10.8397 7.01287 11.1589 8.15031 11.1589C9.28775 11.1589 10.4024 10.8397 11.3675 10.2378C12.3326 9.63582 13.1094 8.77517 13.6097 7.75366C13.1094 6.73216 12.3326 5.87151 11.3675 5.26955C10.4024 4.66759 9.28775 4.34847 8.15031 4.34847C7.01287 4.34847 5.89825 4.66759 4.93316 5.26955C3.96807 5.87151 3.19122 6.73216 2.69092 7.75366Z",
    fill: "#667085"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-1056 -56H150V456C150 458.209 148.209 460 146 460H-1052C-1054.21 460 -1056 458.209 -1056 456V-56Z",
    stroke: "#DADADA",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1397_6495"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1072,
    y: -302,
    width: 1238,
    height: 830,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1397_6495"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1056 -56H150V456C150 458.209 148.209 460 146 460H-1052C-1054.21 460 -1056 458.209 -1056 456V-56Z",
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEyeOutline);
export default ForwardRef;